import { Button } from "@src/lib/ui/Button";
import { useNewModule } from "@src/features/libraryItem/module/hooks/useNewModule";
import { AiChatType } from "@src/types.generated";
import NewLibraryItemDialog from "./NewLibraryItemDialog";
import type { AiChatFragment } from "@src/features/assistantChat/aiChat.generated";

export const MODULE_OUTLINE_TITLE = "Create module with AI";
export const MODULE_OUTLINE_DESCRIPTION =
  "Describe your training goals, topics and roles or attach existing materials.\nOpus AI will turn them into a complete editable training module.";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onStartNewChat: () => void;
  onImportArticulate?: () => void;
  initialInput?: string;
  enableChatHistory?: boolean;
  onSelectHistoricalChat?: (chat: AiChatFragment) => void;
}

const NewModuleDialog: React.FC<Props> = ({
  open,
  onOpenChange,
  onStartNewChat,
  onImportArticulate,
  initialInput,
  enableChatHistory,
  onSelectHistoricalChat,
}) => {
  const createNewModule = useNewModule(() => {
    onOpenChange(false);
  });

  const FooterButtons = (
    <>
      <Button
        key="scratch"
        variant="outline"
        className="flex-1 text-primary"
        onClick={() => createNewModule()}
      >
        New module from scratch
      </Button>
      <Button
        key="articulate"
        variant="outline"
        className="flex-1 text-primary"
        onClick={onImportArticulate}
      >
        Import Articulate Rise 360
      </Button>
    </>
  );

  return (
    <NewLibraryItemDialog
      open={open}
      onOpenChange={onOpenChange}
      dialogTitle="New Module"
      contentTitle={MODULE_OUTLINE_TITLE}
      contentDescription={MODULE_OUTLINE_DESCRIPTION}
      chatType={AiChatType.ModuleOutline}
      FooterButtons={FooterButtons}
      onStartNewChat={onStartNewChat}
      placeholder="Example: Onboarding for new servers - cover menu knowledge, service steps, and safety protocols. Current handbook is attached."
      initialInput={initialInput}
      enableChatHistory={enableChatHistory}
      onSelectHistoricalChat={onSelectHistoricalChat}
    />
  );
};

export default NewModuleDialog;
